module.exports = "//cdn.mxpnl.com/static/asset-cache/a653f3c5787b014035676f0e1aa6d190/iron/common/widgets/user-icon/empty-icon.svg";